export default __webpack_public_path__ + "static/media/Qvideo.66e16261.mp4";